import React from "react";
import { withRouter } from 'react-router-dom';
import { getQueryStringParams } from "sharedUtils/navUtils";
import RakutenCommissionData from './RakutenCommissionData';
import AvantLinkCommissionData from './AvantLinkCommissionData';
import ImpactCommissionData from './ImpactCommissionData';
import CJAffiliateCommissionData from './CJAffiliateCommissionData';
import PartnerizeCommissionData from './PartnerizeCommissionData';
import AwinCommissionData from './AwinCommissionData';
import AscendCommissionData from "./AscendCommissionData";
import AmazonCommissionData from "./AmazonCommissionData";
import ShareASaleCommissionData from "./ShareASaleCommissionData";
import FlexoffersCommissionData from "./FlexoffersCommissionData";
import DigiDipCommissionData from "./DigiDipCommissionData";

class AffiliateCommissionData extends React.Component {

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
    }

    renderAffiliateComponent = () => {
        const { affiliateProgramManager } = this.props;

        switch (affiliateProgramManager.name) {
            case "CJAffiliate":
                return <CJAffiliateCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} deviceSize={this.props.deviceSize} />
            case "Rakuten":
                return <RakutenCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "Ascend":
                return <AscendCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "Awin":
                return <AwinCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "AvantLink":
                return <AvantLinkCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "Impact":
                return <ImpactCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "Partnerize":
                return <PartnerizeCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "ShareASale":
                return <ShareASaleCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "Amazon":
                return <AmazonCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "Flexoffers":
                return <FlexoffersCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            case "DigiDip":
                return <DigiDipCommissionData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.props.affiliateCommissionId ?? ""} />
            default:
                return <h1>Unknown Affiliate Program</h1>;
        }
    }

    render() {
        return (
            <>
                {this.renderAffiliateComponent()}
            </>
        )
    }
}

export default withRouter(AffiliateCommissionData);
